import API from "./server.api.js";

export const getBlogs = `${API}/blog/getBlogs`;
export const uploadBlog = `${API}/blog/uploadBlog`;
export const singleBlog = `${API}/blog/singleBlog`
export const summarizeBlog = `${API}/blog/summarizeBlog`;

